module.exports = __webpack_public_path__ + "static/basics_of_video_processing_2-3479c22823ed609556bc0d0e9e34e742.png";